<template>
  <div class="doc-placeholder">
    <img width="200" height="200" class="doc-placeholder__icon" src="./not_supported_format.svg" alt="not supported format">
    <div class="doc-placeholder__text">
      <p class="doc-placeholder__text-title">Просмотр указанного формата сейчас недоступен</p>
      <p>Вы можете открыть файл, скачав его на компьютер</p>
    </div>
    <SButton size="small" variant="secondary" @click="emit('download-file')">Скачать файл</SButton>
  </div>
</template>

<script lang="ts" setup>
import {SButton} from "@/components";
const emit = defineEmits(['download-file'])
</script>

<style lang="scss" scoped>
.doc-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &__icon {
    display: block;
    margin-bottom: 24px;
  }

  &__text {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-text-primary);
    text-align: center;
    margin-bottom: 24px;
  }
  &__text-title {
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
  }
}
</style>
